<template>
  <div>
    <!-- Begin Mailchimp Signup Form -->
    <!-- <link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css"> -->
    
    <div id="mc_embed_signup">
      <form action="https://centrofluminense.us5.list-manage.com/subscribe/post?u=e7c3bb60ef995a0d70fbf93d4&amp;id=2ddbd32464" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
          <div id="mc_embed_signup_scroll">
        <!-- <h2>Subscribe</h2> -->
      <div class="indicates-required"><span class="asterisk">*</span> Campos obrigatórios</div>
      <div class="mc-field-group">
        <label for="mce-NOME">Nome  <span class="asterisk">*</span>
      </label>
        <input type="text" value="" name="NOME" class="required" id="mce-NOME">
      </div>
      <div class="mc-field-group">
        <label for="mce-SOBRENOME">Sobrenome  <span class="asterisk">*</span>
      </label>
        <input type="text" value="" name="SOBRENOME" class="required" id="mce-SOBRENOME">
      </div>
      <div class="mc-field-group">
        <label for="mce-EMAIL">Email  <span class="asterisk">*</span>
      </label>
        <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
      </div>
      <div class="mc-field-group">
        <label for="mce-MMERGE12">Especialidade  <span class="asterisk">*</span>
      </label>
        <input type="text" value="" name="MMERGE12" class="required" id="mce-MMERGE12">
      </div>
      <div class="mc-field-group size1of2">
        <label for="mce-MMERGE3">Telefone Celular  <span class="asterisk">*</span>
      </label>
        <input type="text" name="MMERGE3" class="required" value="" id="mce-MMERGE3">
      </div>
        <div id="mce-responses" class="clear">
          <div class="response" id="mce-error-response" style="display:none"></div>
          <div class="response" id="mce-success-response" style="display:none"></div>
        </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_e7c3bb60ef995a0d70fbf93d4_2ddbd32464" tabindex="-1" value=""></div>
          <div class="clear"><input type="submit" value="Quero garantir minha vaga!" name="subscribe" id="mc-embedded-subscribe" class="button my-4"></div>
          </div>
      </form>
    </div>
    
    <!--End mc_embed_signup-->
  </div>
</template>

<script>
export default {
  name: "FormMailchimp",
  mounted() {
    const fnames = new Array(); 
    const ftypes = new Array();
    fnames[1]='NOME';
    ftypes[1]='text';
    fnames[2]='SOBRENOME';
    ftypes[2]='text';
    fnames[0]='EMAIL';
    ftypes[0]='email';
    fnames[12]='MMERGE12';
    ftypes[12]='text';
    fnames[3]='MMERGE3';
    ftypes[3]='phone';
  },
}
</script>

<style lang="scss">
@import '@/variables/style.scss';
  #mc_embed_signup{
    display: flex;
    flex-direction: column;
    justify-content: center;
    // background:#fff;
    // clear:left;
    font:14px Helvetica,Arial,sans-serif;
    input {
      background: #FFFFFF;
      color: #101010;
      height: 40px;
      &[type=submit] {
        height: 50px;
        color: $primary;
        background-color: #FFFFFF;
        font-weight: bold;
        font-size: 1.1rem;
      }
    }
    #mc-embedded-subscribe {
      width: 100%;
    }
  }
  /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
    We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
</style>